const TRADE_LABELS: Record<string, string> = {
  electric: "Electric",
  hvac: "HVAC",
  plumbing: "Plumbing",
  roofing: "Roofing",
};

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

export function formatBillingDate(date: string | null): string {
  if (!date) return "—";

  return dateFormatter.format(new Date(`${date}T00:00:00Z`));
}

export function formatBillingTrade(trade: string | null): string {
  if (!trade) return "—";

  return TRADE_LABELS[trade] ?? trade;
}

export function formatBillingFrequency(frequency: string | null): string {
  if (!frequency) return "—";

  return frequency.charAt(0).toUpperCase() + frequency.slice(1);
}

export function formatBillingQuantity(quantity: string | null): string {
  if (quantity === null) return "—";

  return String(Number(quantity));
}

export function formatBillingSubscriptionName(
  productName: string,
  trade: string | null,
): string {
  if (!trade) return productName;

  return `${productName} · ${formatBillingTrade(trade)}`;
}
